export default __webpack_public_path__ + "static/media/bg-pattern-bottom-mobile.593835ec.svg";